import { LAYOUTS_CONFIG, OrderViewLayout } from "@streamllc/shared/ocb"
import { useMemo } from "react"


export default function useLayoutConfig(layoutNumber: OrderViewLayout) {
  return useMemo(() => LAYOUTS_CONFIG[layoutNumber], [layoutNumber])
}
